/**
 * Draws the current video frame into a temporary canvas and returns RGBA ImageData.
 *
 * @param {HTMLVideoElement} video
 * @param {number} maxWidth
 * @returns {ImageData | null}
 */
export function videoFrameToImageData(video, maxWidth) {
  const vw = video.videoWidth;
  const vh = video.videoHeight;
  if (!vw || !vh || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
    return null;
  }
  const scale = Math.min(1, maxWidth / vw);
  const tw = Math.max(1, Math.round(vw * scale));
  const th = Math.max(1, Math.round(vh * scale));
  const canvas = document.createElement('canvas');
  canvas.width = tw;
  canvas.height = th;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.drawImage(video, 0, 0, tw, th);
  return ctx.getImageData(0, 0, tw, th);
}
